<template>
  <div class="m-menu-group-header" @click="onExpandMenu('1')">
    <div class="left">
      {{ $t('header.generalSecurityCertification') }}
    </div>
    <div class="right">
      <UpDown :type="getType('1')" />
    </div>
  </div>
  <div v-show="isExpand('1')" class="m-menu-items">
    <div
      v-at-navigation="'main_menu::overview'"
      class="m-menu-item"
      @click="e => toCertificationPage(CERTIFICATION_TYPE.gsc, 'overview')"
    >
      {{ $t('header.Overview') }}
    </div>
    <div
      v-at-navigation="'main_menu::online-video-courses'"
      class="m-menu-item"
      @click="e => toCertificationPage(CERTIFICATION_TYPE.gsc, 'online-video-courses')"
    >
      {{ $t('header.onlineVideoCourses') }}
    </div>
    <div
      v-at-navigation="'main_menu::classroom'"
      class="m-menu-item"
      @click="e => toCertificationPage(CERTIFICATION_TYPE.gsc, 'classroom')"
    >
      {{ $t('header.instructor-ledTraining') }}
    </div>
  </div>
  <div class="m-menu-group-header" @click="onExpandMenu('2')">
    <div class="left">
      {{ $t('header.hikSecurityCertification') }}
    </div>
    <div class="right">
      <UpDown :type="getType('2')" />
    </div>
  </div>
  <div v-show="isExpand('2')" class="m-menu-items">
    <div
      v-at-navigation="'main_menu::overview'"
      class="m-menu-item"
      @click="e => toCertificationPage(CERTIFICATION_TYPE.hsc, 'overview')">
      {{ $t('header.Overview') }}
    </div>
    <div
      v-at-navigation="'main_menu::online-video-courses'"
      class="m-menu-item"
      @click="e => toCertificationPage(CERTIFICATION_TYPE.hsc, 'online-video-courses')"
    >
      {{ $t('header.onlineVideoCourses') }}
    </div>
    <div
      v-at-navigation="'main_menu::classroom'"
      class="m-menu-item"
      @click="e => toCertificationPage(CERTIFICATION_TYPE.hsc, 'classroom')"
    >
      {{ $t('header.instructor-ledTraining') }}
    </div>
  </div>
  <div class="m-menu-group-header">
    <div class="left" style="cursor: pointer;" @click="onMyLearning">
      {{ $t('header.myLearning') }}
    </div>
    <div class="right" />
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue'
import { useStoreHooks } from '@/store/hook'
import UpDown from './updown.vue'
import { useHeaderHook } from '@/utils/moduleHooks/global'
import { CERTIFICATION_TYPE } from '@/utils/config'
import { login } from '@/utils'
export default defineComponent({
  components: {
    UpDown
  },
  emits: ['close'],
  setup (props, ctx) {
    const { getters } = useStoreHooks()
    const {
      toPage,
      toCertificationPage: _toCertificationPage
    } = useHeaderHook()
    const isLogin = getters['global/isLogin']
    const state = reactive({
      expandedKeys: [] as string[]
    })

    const onExpandMenu = (key: string) => {
      const index = state.expandedKeys.findIndex((k) => k === key)
      if (index < 0) {
        state.expandedKeys.push(key)
      } else {
        state.expandedKeys.splice(index, 1)
      }
    }
    const getType = (key: string): number => {
      return state.expandedKeys.includes(key) ? 1 : 0
    }
    const isExpand = (key: string): boolean => {
      return !!state.expandedKeys.includes(key)
    }
    const onMyLearning = () => {
      if (!getters['global/isLogin']) {
        login(`/${window.prefix}/mobile/my-learning`)
      } else {
        ctx.emit('close')
        toPage('/my-learning')
      }
    }
    return {
      isLogin,
      onExpandMenu,
      getType,
      isExpand,
      toCertificationPage (kind: string, target: string) {
        _toCertificationPage(kind, target)
        ctx.emit('close')
      },
      onMyLearning,
      login,
      CERTIFICATION_TYPE
    }
  }
})
</script>
